import React from 'react';

const FundBanner = () => {
    return (
        <div className=''>
        <img src="https://i.ibb.co/hHcmPHs/Frame-8-1.png" alt="" />
       </div>
    );
};

export default FundBanner;